module.exports = __webpack_public_path__ + "static/CloudPay-47773b2df8df94680d6dbfe6d1480fc7.jpg";